<template>
    <div class="booking payment">
        <h3>{{ 'shopcart.payment_types' | trans }}</h3>
        <ul>
            <li
                v-for="({type, image, icon, title, description}) in payments"
                :key="type"
            >
                <div>
                    <i
                        v-if="!isNil(icon)"
                        :class="icon"
                    />
                    <img
                        v-else
                        :src="image"
                    >
                    <aside>
                        <h4>{{ title | trans }}</h4>
                        <p>{{ description | trans }}</p>
                    </aside>
                </div>
                <div>
                    <div
                        :class="{
                            'gl-radiobtn': true,
                            'checked': selected === type
                        }"
                    >
                        <button
                            class="action"
                            style="cursor: pointer;"
                            @click="select(type, image, icon, title, description)"
                        />
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
import { isNil, hasIn, filter } from 'ramda';

const enablePayments = {
    paypal: hasIn('paypal_url', window.groovie) && hasIn('paypal_bussines', window.groovie),
    cash: true,
    tpv: hasIn('redsys_url', window.groovie) && hasIn('redsys_success', window.groovie)
};

const paymentsText = hasIn('payments', window.groovie) ? window.groovie.payments : null;

export default {
    name: 'payment',
    props: {
        data: {
            type: Object,
            default: () => ({
                    name: '',
                    lastName: '',
                    phone: '',
                    email: '',
                    address: '',
                    city: '',
                    country: '',
                    postal: '',
                    observations: '',
                    payment: {
                        type: 'paypal'
                    }
                })
        }
    },
    data() {
      return {
        selected: hasIn('payment', this.data) && hasIn('type', this.data.payment) ? this.data.payment.type : 'paypal',
        payments: []
      };
    },
    methods: {
        isNil(value) {
            return isNil(value);
        },
        select(type, image, icon, title, description) {
            this.selected = type;
            const data = this.data;
            data.payment = {
                type,
                image,
                icon,
                title,
                description
            };
            this.$emit('valid', data);
        }
    },
    mounted() {
        let list = [
            {
                type: 'paypal',
                icon: null,
                image: '/css/front-end/img/logo-paypal.svg',
                title: 'shopcart.payment_paypal_title',
                description: 'shopcart.payment_paypal_description'
            },
            {
                type: 'cash',
                icon: 'icon-money',
                image: null,
                title: 'shopcart.payment_cash_title',
                description: 'shopcart.payment_cash_description'
            },
            {
                type: 'tpv',
                icon: null,
                image: '/css/front-end/img/logoTPV.png',
                title: 'shopcart.payment_tpv_title',
                description: 'shopcart.payment_tpv_description'
            }
        ].map( (payment) => {
            const { type } = payment;
            let { image, title, description, icon } = payment;
            const settings = !isNil(paymentsText) && hasIn(type, paymentsText) ? paymentsText[type] : null;
            
            if (!isNil(settings)) {
                image = hasIn('image', settings) ? settings.image : image;
                icon = hasIn('image', settings) ? settings.icon : icon;
                title = hasIn('title', settings) ? settings.title : title;
                description = hasIn('description', settings) ? settings.description : description;
            }
            return {
                type,
                image,
                icon,
                title,
                description
            };
        });

        list = filter(({ type }) => enablePayments[type], list);
        this.payments = list;
    }
};
</script>



// WEBPACK FOOTER //
// src/sections/Payment.vue